// extracted by mini-css-extract-plugin
export default {"aiSummary":"StrainDescription_aiSummary__GKAEY"};